import React from 'react'

export function TrucatedText({
  text,
  size,
  defaultHeight = '60px'
}) {
  return (
    <div title={text} style={{ overflow: 'hidden', maxHeight: defaultHeight, textAlign: 'left' }}>
      {text.length > size ? `${text.substring(0, size)}...` : text}
    </div>
  )
}
